import getDeviceInfo from '@/lib/base/getDeviceInfo';
import NAVIGATION from '@/constant/navigation.js';
const deviceDetails = getDeviceInfo();
const {viewMode} = deviceDetails;
const isMobile = viewMode === 'phone';

export default [
  {
    path: '/products/:marketSalePageId',
    name: 'productPage',
    component: () => import('@/views/Products/ProductPage.vue'),
    meta: {
      hasNavigation: !isMobile,
      requireAuth: true,
      activeTab: NAVIGATION.TABS.LEARNING,
    },
    beforeEnter: (to, from, next) => {
      if (to?.params?.marketSalePageId) {
        next();
      } else {
        next(from);
      }
    },
  },
];
